import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    IAuth,
    IInfo,
    ILogin,
    ILineLogin,
    IFBLogin,
    IGGLogin,
    ILineSignup,
    IFBSignup,
    IGGSignup,
    IChooseMerchant,
    ICreateMerchant,
    IAuthUser,
    ILoginAdmin,
    ITessabarnAdmin,
    IChooseAdmin,
    IAdminParam,
    IPermission,
} from "@interfaces";
import { adminAPI, authApi } from "@api";
import { RootState } from ".";
import { enumExternalMethod } from "@configs";

export const login = createAsyncThunk<IAuth, ILogin>(
    "auth/login",
    async (values: ILogin, { rejectWithValue }) => {
        try {
            const res = await authApi.login(values);
            return res.data.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);
export const loginAdmin = createAsyncThunk<IAuthUser, ILoginAdmin>(
    "authUser/login",
    async (values: ILoginAdmin, { rejectWithValue }) => {
        try {
            const res = await authApi.loginAdmin(values);
            return res.data as IAuthUser;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);
export const chooseAdminTessabarn = createAsyncThunk<ITessabarnAdmin, IChooseAdmin>(
    "auth/chooseAdminTessabarn",
    async (values: IChooseAdmin, { rejectWithValue }) => {
        try {
            const res = await authApi.adminChooseTessabarn(values);
            return res.data.result as ITessabarnAdmin;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);
export const chooseLoginMerchant = createAsyncThunk<IAuth, IChooseMerchant>(
    "auth/chooseLoginMerchant",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.adminMerchantChooseMerchant(values);
            return res.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);
export const getCreateToken = createAsyncThunk<IAuth, ICreateMerchant>(
    "auth/getCreateToken",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.getCreateToken(values);
            return res.data.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);
export const lineLogin = createAsyncThunk<IAuth, ILineLogin>(
    "auth/lineLogin",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.lineLogin(values);
            return res.data.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const lineSignup = createAsyncThunk<IAuth, ILineSignup>(
    "auth/lineSignup",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.lineSignup(values);
            return res.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const fbLogin = createAsyncThunk<IAuth, IFBLogin>(
    "auth/fbLogin",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.fbLogin(values);
            return res.data.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const fbSignup = createAsyncThunk<IAuth, IFBSignup>(
    "auth/fbSignup",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.fbSignup(values);
            return res.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const ggLogin = createAsyncThunk<IAuth, IGGLogin>(
    "auth/ggLogin",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.ggLogin(values);
            return res.data.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const ggSignup = createAsyncThunk<IAuth, IGGSignup>(
    "auth/ggSignup",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.ggSignup(values);
            return res.data as IAuth;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const getInfo = createAsyncThunk<IInfo>(
    "auth/userInfo",
    async (values, { rejectWithValue }) => {
        try {
            const res = await authApi.getInfo();
            return res.data as IInfo;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

export const getAdminGetPermission = createAsyncThunk<IPermission, IAdminParam>(
    "auth/adminGetPermission",
    async (values: IAdminParam, { rejectWithValue }) => {
        try {
            const res = await adminAPI.adminGetPermission(values);
            return res.data.result as IPermission;
        } catch (err: any) {
            return rejectWithValue(err);
        }
    }
);

interface ILine {
    code: string | null;
    state: string;
}
interface IState {
    authUser: IAuthUser | null;
    admin: ITessabarnAdmin | null;
    // auth: IAuth | null;
    auth: ITessabarnAdmin | null;
    isRemember: boolean;
    isLoading: boolean;
    error: string;
    tokenInfoAuth: string;
    userInfo: IInfo | null;
    line?: ILine | null;
    externalLogin: enumExternalMethod | null;
    plan: null;
    editLineToken: string;
    firstTimeUser: boolean;
    productUser: boolean;
    permission: IPermission | null;
}

interface ISetExternalLogin {
    line?: ILine;
    type: enumExternalMethod;
}

const initialState: IState = {
    authUser: null,
    admin: null,
    auth: null,
    isRemember: false,
    isLoading: false,
    error: "",
    tokenInfoAuth: "",
    userInfo: null,
    externalLogin: null,
    plan: null,
    editLineToken: "",
    firstTimeUser: false,
    productUser: false,
    permission: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        logout: () => {
            return initialState;
        },
        setAuth: (state, action) => {
            state.auth = action.payload;
        },
        setInfo: (state, action) => {
            state.userInfo = { ...state.userInfo, ...action.payload };
        },
        setPlan: (state, action) => {
            state.plan = action.payload;
        },
        setRemember: (state, action: PayloadAction<boolean>) => {
            state.isRemember = action.payload;
        },
        setExternalLogin: (state, action: PayloadAction<ISetExternalLogin>) => {
            state.externalLogin = action.payload.type;
            state.line = action.payload.line;
            state.isLoading = true;
        },
        setEditLineToken: (state, action: PayloadAction<string>) => {
            state.editLineToken = action.payload;
        },
        setFirstTimeUser: (state, action: PayloadAction<boolean>) => {
            state.firstTimeUser = action.payload;
            // state.auth = { ...state.auth, isFirstLogin: false };
        },
        setProductUser: (state, action: PayloadAction<boolean>) => {
            state.productUser = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(loginAdmin.fulfilled, (state, action: { payload: IAuthUser }) => {
            if (action.payload.result) {
                state.authUser = action.payload;
            }
            state.isLoading = false;
        });

        builder.addCase(chooseLoginMerchant.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(chooseLoginMerchant.rejected, (state) => {
            state.auth = null;
            state.isLoading = false;
        });
        builder.addCase(
            chooseAdminTessabarn.fulfilled,
            (state, action: { payload: ITessabarnAdmin }) => {
                if (action.payload.token) {
                    state.admin = action.payload;
                    state.auth = action.payload;
                }
                state.isLoading = false;
            }
        );

        builder.addCase(chooseAdminTessabarn.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(chooseAdminTessabarn.rejected, (state) => {
            state.admin = null;
            state.isLoading = false;
        });
        // builder.addCase(getCreateToken.fulfilled, (state, action: { payload: IAuth }) => {
        //     if (action.payload.create_token) {
        //         state.auth = { ...state.auth, ...action.payload };
        //     }
        //     state.isLoading = false;
        // });

        builder.addCase(getCreateToken.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(getCreateToken.rejected, (state) => {
            state.isLoading = false;
        });
        builder.addCase(getInfo.fulfilled, (state, action: { payload: IInfo }) => {
            state.userInfo = action.payload;
        });

        builder.addCase(getInfo.rejected, (state) => {
            state.userInfo = null;
        });
        builder.addCase(lineLogin.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.line = null;
            state.isLoading = false;
        });

        builder.addCase(lineSignup.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.line = null;
            state.isLoading = false;
        });
        builder.addCase(fbLogin.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.isLoading = false;
        });
        builder.addCase(fbSignup.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.isLoading = false;
        });
        builder.addCase(ggLogin.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.isLoading = false;
        });
        builder.addCase(ggSignup.rejected, (state) => {
            state.auth = null;
            state.externalLogin = null;
            state.isLoading = false;
        });
        builder.addCase(getAdminGetPermission.pending, (state) => {
            // state.permission = state.permission;
            state.isLoading = true;
        });
        builder.addCase(
            getAdminGetPermission.fulfilled,
            (state, action: PayloadAction<IPermission>) => {
                state.permission = action.payload;
                state.isLoading = false;
            }
        );
        builder.addCase(getAdminGetPermission.rejected, (state) => {
            state.permission = null;
            state.isLoading = false;
        });
    },
});

export const selectAuth = (state: RootState) => state.auth;

export const {
    logout,
    setAuth,
    setInfo,
    setRemember,
    setExternalLogin,
    setPlan,
    // reStoreAuth,
    setEditLineToken,
    setFirstTimeUser,
    setProductUser,
} = authSlice.actions;

export default authSlice.reducer;
